// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manager-dashboard-page {
  min-height: 100vh;
  background:
    linear-gradient(180deg, #f8fbff 0%, #f3f7fc 46%, #eef4fb 100%) !important;
  color: #0f172a;
}

.manager-dashboard-page .container-fluid {
  max-width: 100%;
  padding-left: 18px;
  padding-right: 18px;
}

.manager-dashboard-shell {
  width: 100%;
  padding: 10px 0 24px;
}

.manager-dashboard-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 12px;
  margin-bottom: 12px;
}

.manager-dashboard-hero-copy,
.manager-dashboard-company-card,
.manager-dashboard-filter-card,
.manager-stat-card,
.manager-panel {
  position: relative;
  border: 1px solid rgba(203, 213, 225, 0.9);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease;
}

.manager-dashboard-hero-copy,
.manager-dashboard-company-card,
.manager-dashboard-filter-card {
  overflow: hidden;
}

.manager-dashboard-hero-copy {
  min-height: 128px;
  padding: 18px 20px 16px;
  background:
    linear-gradient(90deg, rgba(37, 99, 235, 0.08) 0%, rgba(255, 255, 255, 0.98) 34%),
    #ffffff !important;
  border-left: 4px solid #2563eb;
}

.manager-dashboard-hero-copy::after {
  display: none !important;
  content: none !important;
}

.manager-dashboard-company-card {
  min-height: 128px;
  padding: 14px;
}

.manager-dashboard-eyebrow,
.manager-panel-kicker,
.manager-stat-label,
.manager-dashboard-label {
  color: #64748b;
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.manager-dashboard-title {
  margin: 6px 0 5px;
  color: #071226;
  font-size: clamp(24px, 2vw, 31px);
  font-weight: 850;
  line-height: 1.08;
}

.manager-dashboard-subtitle {
  max-width: 780px;
  margin: 0;
  color: #40516a;
  font-size: 13px;
  line-height: 1.55;
}

.manager-dashboard-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 11px;
}

.manager-dashboard-meta span {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 5px 11px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.manager-dashboard-meta span:hover {
  background: #dbeafe;
  transform: translateY(-1px);
}

.manager-dashboard-label {
  display: block;
  margin-bottom: 7px;
}

.manager-dashboard-help {
  margin: 9px 0 0;
  color: #64748b;
  font-size: 12.5px;
  line-height: 1.5;
}

.manager-dashboard-filter-card {
  padding: 12px;
  margin-bottom: 12px;
  background: rgba(255, 255, 255, 0.98);
}

.manager-filter-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  align-items: end;
}

.manager-filter-field {
  width: 100%;
}

.manager-filter-date {
  width: 100%;
}

.manager-filter-action {
  display: flex;
  align-items: end;
}

.manager-filter-action button {
  width: 100%; /* makes Reset align properly */
}

.manager-dashboard-input,
.manager-dashboard-dropdown,
.manager-dashboard-calendar,
.manager-dashboard-page .p-dropdown,
.manager-dashboard-page .p-calendar,
.manager-dashboard-page .p-inputtext {
  width: 100%;
}

.manager-dashboard-page .p-dropdown,
.manager-dashboard-page .p-calendar .p-inputtext,
.manager-dashboard-input {
  min-height: 42px;
  border: 1px solid #cbd5e1 !important;
  border-radius: 11px;
  color: #0f172a !important;
  background: #f8fafc !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);
  transition:
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    background-color 0.18s ease,
    transform 0.18s ease;
}

.manager-dashboard-page .p-dropdown {
  display: flex;
  align-items: center;
  overflow: visible;
}

.manager-dashboard-page .p-dropdown .p-dropdown-label {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 9px 42px 9px 12px;
  color: #334155 !important;
  background: transparent !important;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.manager-dashboard-page .p-dropdown .p-dropdown-trigger {
  width: 40px;
  flex: 0 0 40px;
  color: #0f172a !important;
  background: transparent !important;
}

.manager-dashboard-page .p-dropdown .p-dropdown-trigger-icon {
  display: inline-block !important;
  color: #0f172a !important;
  font-size: 12px;
  opacity: 1 !important;
  transition: transform 0.18s ease;
}

.manager-dashboard-page .p-dropdown.p-inputwrapper-focus .p-dropdown-trigger-icon {
  transform: rotate(180deg);
}

.manager-dashboard-page .p-dropdown .p-dropdown-clear-icon {
  right: 38px;
  color: #64748b !important;
}

.manager-dashboard-input[type="select"],
select.manager-dashboard-input {
  appearance: auto;
  padding-right: 34px;
  background-color: #f8fafc !important;
}

.manager-dashboard-page .p-calendar {
  display: flex;
  align-items: stretch;
}

.manager-dashboard-page .p-calendar .p-inputtext {
  min-width: 0;
  padding: 9px 42px 9px 12px;
  color: #334155 !important;
  font-size: 13px;
  font-weight: 600;
}

.manager-dashboard-page .p-calendar .p-datepicker-trigger {
  width: 40px;
  margin-left: -40px;
  border: 0;
  border-left: 1px solid #dbe4ef;
  border-radius: 0 11px 11px 0;
  background: #eef4ff !important;
  color: #334155 !important;
  z-index: 1;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.manager-dashboard-page .p-dropdown:not(.p-disabled):hover,
.manager-dashboard-page .p-dropdown.p-focus,
.manager-dashboard-page .p-dropdown.p-inputwrapper-focus,
.manager-dashboard-page .p-calendar .p-inputtext:enabled:hover,
.manager-dashboard-page .p-calendar .p-inputtext:enabled:focus,
.manager-dashboard-input:focus {
  border-color: #60a5fa !important;
  background: #ffffff !important;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
}

.manager-dashboard-page .p-dropdown:not(.p-disabled):hover .p-dropdown-label,
.manager-dashboard-page .p-dropdown:not(.p-disabled):hover .p-dropdown-trigger-icon {
  color: #0f172a !important;
  background: transparent !important;
}

.manager-dashboard-page .p-calendar:hover .p-datepicker-trigger,
.manager-dashboard-page .p-calendar .p-inputtext:enabled:focus + .p-datepicker-trigger {
  background: #dbeafe !important;
  color: #1d4ed8 !important;
}

.manager-dashboard-dropdown-panel {
  overflow: hidden;
  border: 1px solid #dbe4ef !important;
  border-radius: 13px !important;
  background: #ffffff !important;
  box-shadow: 0 22px 52px rgba(15, 23, 42, 0.18) !important;
  animation: managerDropdownIn 0.16s ease-out;
}

@keyframes managerDropdownIn {
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.99);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.manager-dashboard-dropdown-panel .p-dropdown-header {
  padding: 10px !important;
  border-bottom: 1px solid #e5eaf1 !important;
  background: #f8fafc !important;
}

.manager-dashboard-dropdown-panel .p-dropdown-filter {
  border: 1px solid #cbd5e1 !important;
  border-radius: 9px !important;
  color: #0f172a !important;
  background: #ffffff !important;
}

.manager-dashboard-dropdown-panel .p-dropdown-items {
  padding: 6px !important;
  background: #ffffff !important;
}

.manager-dashboard-dropdown-panel .p-dropdown-item {
  margin: 2px 0 !important;
  padding: 9px 10px !important;
  border-radius: 9px !important;
  color: #334155 !important;
  background: transparent !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  transition: background-color 0.16s ease, color 0.16s ease, transform 0.16s ease;
}

.manager-dashboard-dropdown-panel .p-dropdown-item.p-highlight,
.manager-dashboard-dropdown-panel .p-dropdown-item.p-focus,
.manager-dashboard-dropdown-panel .p-dropdown-item:hover {
  color: #1d4ed8 !important;
  background: #eff6ff !important;
  transform: translateX(2px);
}

.manager-dashboard-reset {
  width: 100%;
  min-height: 42px;
  border: 0;
  border-radius: 11px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #ffffff;
  font-weight: 850;
  box-shadow: 0 10px 18px rgba(37, 99, 235, 0.22);
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.manager-dashboard-reset:hover {
  color: #ffffff;
  transform: translateY(-1px);
  box-shadow: 0 14px 24px rgba(37, 99, 235, 0.28);
}

.manager-dashboard-reset:active {
  transform: translateY(0);
  box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);
}

.manager-dashboard-error {
  margin-top: 10px;
  color: #dc2626;
  font-size: 13px;
  font-weight: 700;
}
.manager-summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
  margin-bottom: 12px;
}
.manager-stat-card {
  min-height: 96px;
  padding: 12px;
  overflow: hidden;
  cursor: pointer;
}

.manager-stat-card::after {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 3px;
  background: linear-gradient(90deg, #2563eb, rgba(37, 99, 235, 0));
  opacity: 0;
  transition: opacity 0.2s ease;
}

.manager-stat-card:hover,
.manager-panel:hover,
.manager-dashboard-filter-card:hover {
  border-color: #c6d4e4;
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.09);
}

.manager-stat-card:hover {
  transform: translateY(-2px);
}

.manager-stat-card-clickable:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 3px;
}

.manager-stat-card:hover::after {
  opacity: 1;
}

.manager-stat-topline {
  display: flex;
  align-items: center;
  gap: 7px;
}

.manager-stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #eff6ff;
  color: #2563eb;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.manager-stat-icon svg {
  width: 17px;
  height: 17px;
}

.manager-stat-label {
  min-width: 0;
  line-height: 1.2;
}

.manager-stat-card:hover .manager-stat-icon {
  background: #dbeafe;
  transform: scale(1.05);
}

.manager-stat-value {
  margin-top: 8px;
  color: #0b1220;
  font-size: 24px;
  font-weight: 850;
  line-height: 1;
}

.manager-stat-note {
  display: block;
  margin-top: 5px;
  color: #64748b;
  font-size: 11.5px;
  line-height: 1.25;
}

.manager-dashboard-row {
  --bs-gutter-x: 12px;
  --bs-gutter-y: 12px;
  margin-top: 0 !important;
  margin-bottom: 12px;
}

.manager-panel {
  height: 100%;
  padding: 13px;
}

.manager-panel-compact {
  min-height: 225px;
}

.manager-pipeline-panel,
.manager-pipeline-panel .p-card-body,
.manager-pipeline-panel .p-card-content {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.manager-pipeline-panel {
  height: 430px;
}

.manager-panel-table {
  overflow: hidden;
}

.manager-coverage-panel,
.manager-coverage-panel .p-card-body,
.manager-coverage-panel .p-card-content {
  display: flex;
  flex-direction: column;
}

.manager-coverage-panel .p-card-body,
.manager-coverage-panel .p-card-content {
  height: 100%;
  min-height: 0;
}

.manager-coverage-panel .manager-table {
  flex: 1 1 auto;
  min-height: 0;
}

.manager-coverage-panel .p-datatable-wrapper {
  flex: 1 1 auto;
  min-height: 0;
}

.manager-candidate-panel,
.manager-team-panel {
  height: 500px;
}

.manager-role-panel {
  height: 440px;
}

.manager-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 11px;
}

.manager-panel-title {
  margin: 4px 0 0;
  color: #071226;
  font-size: 14px;
  font-weight: 850;
}

.manager-pipeline-list,
.manager-team-list {
  display: grid;
  gap: 9px;
}

.manager-pipeline-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.manager-pipeline-row {
  display: grid;
  gap: 6px;
  padding: 3px 0;
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease, padding 0.18s ease;
}

.manager-pipeline-row:hover,
.manager-pipeline-row-active {
  padding: 7px 8px;
  border-radius: 10px;
  background: #f8fbff;
  transform: translateX(2px);
}

.manager-pipeline-copy {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  color: #334155;
  font-size: 13px;
  font-weight: 750;
}

.manager-pipeline-copy strong {
  color: #0b1220;
}

.manager-pipeline-track {
  overflow: hidden;
  height: 8px;
  border-radius: 999px;
  background: #e8eef7;
}

.manager-pipeline-fill {
  height: 100%;
  border-radius: inherit;
  background: #2563eb;
  transition: width 0.5s ease;
}

.manager-panel-clear {
  min-height: 30px;
  padding: 5px 12px;
  border: 1px solid #bfdbfe;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12px;
  font-weight: 800;
  transition: background-color 0.18s ease, transform 0.18s ease;
}

.manager-panel-clear:hover {
  background: #dbeafe;
  transform: translateY(-1px);
}

.manager-pipeline-candidates-panel {
  min-height: 345px;
}

.manager-pipeline-screening {
  background: #0ea5e9;
}

.manager-pipeline-interview {
  background: #14b8a6;
}

.manager-pipeline-final-round {
  background: #f59e0b;
}

.manager-pipeline-selected {
  background: #22c55e;
}

.manager-pipeline-rejected {
  background: #ef4444;
}

.manager-pipeline-received {
  background: #2563eb;
}

.manager-pipeline-offered {
  background: #8b5cf6;
}

.manager-pipeline-placed {
  background: #22c55e;
}

.manager-pipeline-panel-round {
  background: #f59e0b;
}

.manager-pipeline-shortlisted {
  background: #0ea5e9;
}

.manager-pipeline-documentation {
  background: #6366f1;
}

.manager-pipeline-task-assessment {
  background: #ec4899;
}

.manager-pipeline-hold {
  background: #64748b;
}

.manager-team-list {
  max-height: 414px;
  overflow-y: auto;
  padding-right: 4px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.manager-summary-grid::-webkit-scrollbar,
.manager-pipeline-list::-webkit-scrollbar,
.manager-team-list::-webkit-scrollbar,
.manager-dashboard-page .p-datatable-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.manager-summary-grid::-webkit-scrollbar-thumb,
.manager-pipeline-list::-webkit-scrollbar-thumb,
.manager-team-list::-webkit-scrollbar-thumb,
.manager-dashboard-page .p-datatable-wrapper::-webkit-scrollbar-thumb {
  border: 2px solid transparent;
  border-radius: 999px;
  background: #cbd5e1;
  background-clip: padding-box;
}

.manager-team-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 8px;
  padding: 11px;
  border: 1px solid #dbe4ef;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
}

.manager-team-row:hover {
  border-color: #bfdbfe;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.manager-team-metrics {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.manager-team-metrics span {
  padding: 4px 9px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 11.5px;
  font-weight: 800;
}

.manager-table {
  overflow: hidden;
  border: 1px solid #d8e1ec;
  border-radius: 10px;
  background: #ffffff;
  font-size: 12.5px;
}

.manager-table .p-datatable-thead > tr > th {
  border-color: #d8e1ec !important;
  border-right: 1px solid #d8e1ec !important;
  background: linear-gradient(180deg, #f8fafc 0%, #f3f7fb 100%) !important;
  color: #475569;
  font-size: 10.5px;
  font-weight: 850;
  letter-spacing: 0.06em;
  padding: 10px;
  text-transform: uppercase;
}

.manager-table .p-datatable-tbody > tr > td {
  border-color: #e2e8f0 !important;
  border-right: 1px solid #e2e8f0 !important;
  color: #334155;
  padding: 9px 10px;
  vertical-align: middle;
  transition: background-color 0.16s ease, color 0.16s ease;
}

.manager-table .p-datatable-thead > tr > th:last-child,
.manager-table .p-datatable-tbody > tr > td:last-child {
  border-right: 0 !important;
}

.manager-table .p-datatable-tbody > tr:nth-child(even) > td {
  background: #fcfdff;
}

.manager-table .p-datatable-tbody > tr:hover > td {
  background: #eff6ff !important;
}

.manager-table .p-datatable-tbody > tr:last-child > td {
  border-bottom: 0 !important;
}

.manager-table .p-datatable-emptymessage > td {
  border: 0 !important;
  color: #64748b;
  padding: 20px 12px !important;
}

.manager-dashboard-page .p-datatable-scrollable .p-datatable-wrapper {
  border-radius: 0 0 10px 10px;
}

.manager-dashboard-page .p-datatable-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.manager-table-strong {
  color: #0b1220;
  font-weight: 850;
}

.manager-table-muted {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.manager-card-detail-table-wrap {
  max-height: 430px;
  overflow: auto;
  border: 1px solid #d8e1ec;
  border-radius: 10px;
  background: #ffffff;
}

.manager-card-detail-table {
  width: 100%;
  min-width: 980px;
  border-collapse: collapse;
  color: #334155;
  font-size: 12.5px;
}

.manager-card-detail-table th,
.manager-card-detail-table td {
  border-right: 1px solid #e2e8f0;
  border-bottom: 1px solid #e2e8f0;
  padding: 9px 10px;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
}

.manager-card-detail-table th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: linear-gradient(180deg, #f8fafc 0%, #f3f7fb 100%);
  color: #475569;
  font-size: 10.5px;
  font-weight: 850;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.manager-card-detail-table tr:nth-child(even) td {
  background: #fcfdff;
}

.manager-card-detail-empty {
  padding: 20px 12px;
  color: #64748b;
  font-size: 13px;
}

.manager-badge {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 4px 9px;
  border-radius: 999px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 11px;
  font-weight: 850;
  white-space: nowrap;
}

.manager-badge-screening {
  background: #e0f2fe;
  color: #0369a1;
}

.manager-badge-interview {
  background: #ccfbf1;
  color: #0f766e;
}

.manager-badge-final-round {
  background: #fef3c7;
  color: #92400e;
}

.manager-badge-selected {
  background: #dcfce7;
  color: #15803d;
}

.manager-badge-rejected {
  background: #fee2e2;
  color: #b91c1c;
}

.manager-badge-received {
  background: #eff6ff;
  color: #1d4ed8;
}

.manager-badge-offered {
  background: #f5f3ff;
  color: #6d28d9;
}

.manager-badge-placed {
  background: #dcfce7;
  color: #15803d;
}

.manager-badge-panel-round {
  background: #fef3c7;
  color: #92400e;
}

.manager-badge-shortlisted {
  background: #e0f2fe;
  color: #0369a1;
}

.manager-badge-documentation {
  background: #e0e7ff;
  color: #4338ca;
}

.manager-badge-task-assessment {
  background: #fce7f3;
  color: #be185d;
}

.manager-badge-hold {
  background: #f1f5f9;
  color: #475569;
}

.manager-dashboard-page .p-card .p-card-body,
.manager-dashboard-page .p-card .p-card-content {
  padding: 0 !important;
}

.manager-dashboard-page .p-datatable .p-paginator {
  border: 0;
  border-top: 1px solid #e2e8f0;
}

@media (prefers-reduced-motion: reduce) {
  .manager-dashboard-page *,
  .manager-dashboard-page *::before,
  .manager-dashboard-page *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

@media (max-width: 1399.98px) {
  .manager-summary-grid {
    grid-template-columns: repeat(7, minmax(128px, 1fr));
  }

  .manager-filter-grid {
    grid-template-columns: repeat(3, minmax(180px, 1fr));
  }

  .manager-candidate-panel,
  .manager-team-panel,
  .manager-role-panel {
    height: auto;
  }

  .manager-pipeline-panel {
    height: 390px;
  }

  .manager-team-list {
    max-height: 360px;
  }
}

@media (max-width: 991.98px) {
  .manager-dashboard-hero {
    grid-template-columns: 1fr;
  }

  .manager-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .manager-summary-grid {
    grid-template-columns: repeat(7, minmax(132px, 1fr));
  }

  .manager-dashboard-page .container-fluid {
    padding-left: 12px;
    padding-right: 12px;
  }
}

@media (max-width: 575.98px) {
  .manager-dashboard-shell {
    padding-top: 8px;
  }

  .manager-dashboard-hero-copy,
  .manager-dashboard-company-card,
  .manager-dashboard-filter-card,
  .manager-stat-card,
  .manager-panel {
    border-radius: 12px;
  }

  .manager-dashboard-hero-copy,
  .manager-panel,
  .manager-stat-card {
    padding: 13px;
  }

  .manager-summary-grid,
  .manager-filter-grid {
    grid-template-columns: 1fr;
  }

  .manager-summary-grid {
    grid-template-columns: repeat(7, minmax(132px, 1fr));
  }

  .manager-pipeline-panel {
    height: 360px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ATSComponents/Dashboard/ManagerDashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB;6EAC2E;EAC3E,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;EAKE,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C;;;;8BAI4B;AAC9B;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB;;sBAEoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;;EAIE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;EAGE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,mDAAmD;EACnD;;;;wBAIsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;EAC9B,yBAAyB;EACzB,UAAU;EACV,yDAAyD;AAC3D;;AAEA;;;;;;EAME,gCAAgC;EAChC,8BAA8B;EAC9B,uDAAuD;AACzD;;AAEA;;EAEE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;EAEE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,yDAAyD;EACzD,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,wBAAwB;EACxB,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,+EAA+E;AACjF;;AAEA;;;EAGE,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,8EAA8E;AAChF;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;EACxB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,iEAAiE;EACjE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;;EAGE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iFAAiF;AACnF;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;;;;EAIE,UAAU;EACV,WAAW;AACb;;AAEA;;;;EAIE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,wEAAwE;EACxE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,+BAA+B;EAC/B,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE;;;IAGE,qCAAqC;IACrC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;;;;IAKE,mBAAmB;EACrB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".manager-dashboard-page {\n  min-height: 100vh;\n  background:\n    linear-gradient(180deg, #f8fbff 0%, #f3f7fc 46%, #eef4fb 100%) !important;\n  color: #0f172a;\n}\n\n.manager-dashboard-page .container-fluid {\n  max-width: 100%;\n  padding-left: 18px;\n  padding-right: 18px;\n}\n\n.manager-dashboard-shell {\n  width: 100%;\n  padding: 10px 0 24px;\n}\n\n.manager-dashboard-hero {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 300px;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.manager-dashboard-hero-copy,\n.manager-dashboard-company-card,\n.manager-dashboard-filter-card,\n.manager-stat-card,\n.manager-panel {\n  position: relative;\n  border: 1px solid rgba(203, 213, 225, 0.9);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease,\n    border-color 0.2s ease,\n    background-color 0.2s ease;\n}\n\n.manager-dashboard-hero-copy,\n.manager-dashboard-company-card,\n.manager-dashboard-filter-card {\n  overflow: hidden;\n}\n\n.manager-dashboard-hero-copy {\n  min-height: 128px;\n  padding: 18px 20px 16px;\n  background:\n    linear-gradient(90deg, rgba(37, 99, 235, 0.08) 0%, rgba(255, 255, 255, 0.98) 34%),\n    #ffffff !important;\n  border-left: 4px solid #2563eb;\n}\n\n.manager-dashboard-hero-copy::after {\n  display: none !important;\n  content: none !important;\n}\n\n.manager-dashboard-company-card {\n  min-height: 128px;\n  padding: 14px;\n}\n\n.manager-dashboard-eyebrow,\n.manager-panel-kicker,\n.manager-stat-label,\n.manager-dashboard-label {\n  color: #64748b;\n  font-size: 10.5px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.manager-dashboard-title {\n  margin: 6px 0 5px;\n  color: #071226;\n  font-size: clamp(24px, 2vw, 31px);\n  font-weight: 850;\n  line-height: 1.08;\n}\n\n.manager-dashboard-subtitle {\n  max-width: 780px;\n  margin: 0;\n  color: #40516a;\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.manager-dashboard-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 11px;\n}\n\n.manager-dashboard-meta span {\n  display: inline-flex;\n  align-items: center;\n  min-height: 30px;\n  padding: 5px 11px;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.manager-dashboard-meta span:hover {\n  background: #dbeafe;\n  transform: translateY(-1px);\n}\n\n.manager-dashboard-label {\n  display: block;\n  margin-bottom: 7px;\n}\n\n.manager-dashboard-help {\n  margin: 9px 0 0;\n  color: #64748b;\n  font-size: 12.5px;\n  line-height: 1.5;\n}\n\n.manager-dashboard-filter-card {\n  padding: 12px;\n  margin-bottom: 12px;\n  background: rgba(255, 255, 255, 0.98);\n}\n\n.manager-filter-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n  align-items: end;\n}\n\n.manager-filter-field {\n  width: 100%;\n}\n\n.manager-filter-date {\n  width: 100%;\n}\n\n.manager-filter-action {\n  display: flex;\n  align-items: end;\n}\n\n.manager-filter-action button {\n  width: 100%; /* makes Reset align properly */\n}\n\n.manager-dashboard-input,\n.manager-dashboard-dropdown,\n.manager-dashboard-calendar,\n.manager-dashboard-page .p-dropdown,\n.manager-dashboard-page .p-calendar,\n.manager-dashboard-page .p-inputtext {\n  width: 100%;\n}\n\n.manager-dashboard-page .p-dropdown,\n.manager-dashboard-page .p-calendar .p-inputtext,\n.manager-dashboard-input {\n  min-height: 42px;\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 11px;\n  color: #0f172a !important;\n  background: #f8fafc !important;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.75);\n  transition:\n    border-color 0.18s ease,\n    box-shadow 0.18s ease,\n    background-color 0.18s ease,\n    transform 0.18s ease;\n}\n\n.manager-dashboard-page .p-dropdown {\n  display: flex;\n  align-items: center;\n  overflow: visible;\n}\n\n.manager-dashboard-page .p-dropdown .p-dropdown-label {\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  padding: 9px 42px 9px 12px;\n  color: #334155 !important;\n  background: transparent !important;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.manager-dashboard-page .p-dropdown .p-dropdown-trigger {\n  width: 40px;\n  flex: 0 0 40px;\n  color: #0f172a !important;\n  background: transparent !important;\n}\n\n.manager-dashboard-page .p-dropdown .p-dropdown-trigger-icon {\n  display: inline-block !important;\n  color: #0f172a !important;\n  font-size: 12px;\n  opacity: 1 !important;\n  transition: transform 0.18s ease;\n}\n\n.manager-dashboard-page .p-dropdown.p-inputwrapper-focus .p-dropdown-trigger-icon {\n  transform: rotate(180deg);\n}\n\n.manager-dashboard-page .p-dropdown .p-dropdown-clear-icon {\n  right: 38px;\n  color: #64748b !important;\n}\n\n.manager-dashboard-input[type=\"select\"],\nselect.manager-dashboard-input {\n  appearance: auto;\n  padding-right: 34px;\n  background-color: #f8fafc !important;\n}\n\n.manager-dashboard-page .p-calendar {\n  display: flex;\n  align-items: stretch;\n}\n\n.manager-dashboard-page .p-calendar .p-inputtext {\n  min-width: 0;\n  padding: 9px 42px 9px 12px;\n  color: #334155 !important;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.manager-dashboard-page .p-calendar .p-datepicker-trigger {\n  width: 40px;\n  margin-left: -40px;\n  border: 0;\n  border-left: 1px solid #dbe4ef;\n  border-radius: 0 11px 11px 0;\n  background: #eef4ff !important;\n  color: #334155 !important;\n  z-index: 1;\n  transition: background-color 0.18s ease, color 0.18s ease;\n}\n\n.manager-dashboard-page .p-dropdown:not(.p-disabled):hover,\n.manager-dashboard-page .p-dropdown.p-focus,\n.manager-dashboard-page .p-dropdown.p-inputwrapper-focus,\n.manager-dashboard-page .p-calendar .p-inputtext:enabled:hover,\n.manager-dashboard-page .p-calendar .p-inputtext:enabled:focus,\n.manager-dashboard-input:focus {\n  border-color: #60a5fa !important;\n  background: #ffffff !important;\n  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;\n}\n\n.manager-dashboard-page .p-dropdown:not(.p-disabled):hover .p-dropdown-label,\n.manager-dashboard-page .p-dropdown:not(.p-disabled):hover .p-dropdown-trigger-icon {\n  color: #0f172a !important;\n  background: transparent !important;\n}\n\n.manager-dashboard-page .p-calendar:hover .p-datepicker-trigger,\n.manager-dashboard-page .p-calendar .p-inputtext:enabled:focus + .p-datepicker-trigger {\n  background: #dbeafe !important;\n  color: #1d4ed8 !important;\n}\n\n.manager-dashboard-dropdown-panel {\n  overflow: hidden;\n  border: 1px solid #dbe4ef !important;\n  border-radius: 13px !important;\n  background: #ffffff !important;\n  box-shadow: 0 22px 52px rgba(15, 23, 42, 0.18) !important;\n  animation: managerDropdownIn 0.16s ease-out;\n}\n\n@keyframes managerDropdownIn {\n  from {\n    opacity: 0;\n    transform: translateY(-4px) scale(0.99);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.manager-dashboard-dropdown-panel .p-dropdown-header {\n  padding: 10px !important;\n  border-bottom: 1px solid #e5eaf1 !important;\n  background: #f8fafc !important;\n}\n\n.manager-dashboard-dropdown-panel .p-dropdown-filter {\n  border: 1px solid #cbd5e1 !important;\n  border-radius: 9px !important;\n  color: #0f172a !important;\n  background: #ffffff !important;\n}\n\n.manager-dashboard-dropdown-panel .p-dropdown-items {\n  padding: 6px !important;\n  background: #ffffff !important;\n}\n\n.manager-dashboard-dropdown-panel .p-dropdown-item {\n  margin: 2px 0 !important;\n  padding: 9px 10px !important;\n  border-radius: 9px !important;\n  color: #334155 !important;\n  background: transparent !important;\n  font-size: 13px !important;\n  font-weight: 600 !important;\n  transition: background-color 0.16s ease, color 0.16s ease, transform 0.16s ease;\n}\n\n.manager-dashboard-dropdown-panel .p-dropdown-item.p-highlight,\n.manager-dashboard-dropdown-panel .p-dropdown-item.p-focus,\n.manager-dashboard-dropdown-panel .p-dropdown-item:hover {\n  color: #1d4ed8 !important;\n  background: #eff6ff !important;\n  transform: translateX(2px);\n}\n\n.manager-dashboard-reset {\n  width: 100%;\n  min-height: 42px;\n  border: 0;\n  border-radius: 11px;\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: #ffffff;\n  font-weight: 850;\n  box-shadow: 0 10px 18px rgba(37, 99, 235, 0.22);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n}\n\n.manager-dashboard-reset:hover {\n  color: #ffffff;\n  transform: translateY(-1px);\n  box-shadow: 0 14px 24px rgba(37, 99, 235, 0.28);\n}\n\n.manager-dashboard-reset:active {\n  transform: translateY(0);\n  box-shadow: 0 8px 16px rgba(37, 99, 235, 0.2);\n}\n\n.manager-dashboard-error {\n  margin-top: 10px;\n  color: #dc2626;\n  font-size: 13px;\n  font-weight: 700;\n}\n.manager-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 10px;\n  margin-bottom: 12px;\n}\n.manager-stat-card {\n  min-height: 96px;\n  padding: 12px;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.manager-stat-card::after {\n  content: \"\";\n  position: absolute;\n  inset: 0 0 auto;\n  height: 3px;\n  background: linear-gradient(90deg, #2563eb, rgba(37, 99, 235, 0));\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.manager-stat-card:hover,\n.manager-panel:hover,\n.manager-dashboard-filter-card:hover {\n  border-color: #c6d4e4;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.09);\n}\n\n.manager-stat-card:hover {\n  transform: translateY(-2px);\n}\n\n.manager-stat-card-clickable:focus-visible {\n  outline: 2px solid #2563eb;\n  outline-offset: 3px;\n}\n\n.manager-stat-card:hover::after {\n  opacity: 1;\n}\n\n.manager-stat-topline {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.manager-stat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  border: 1px solid #dbeafe;\n  border-radius: 10px;\n  background: #eff6ff;\n  color: #2563eb;\n  transition: transform 0.2s ease, background-color 0.2s ease;\n}\n\n.manager-stat-icon svg {\n  width: 17px;\n  height: 17px;\n}\n\n.manager-stat-label {\n  min-width: 0;\n  line-height: 1.2;\n}\n\n.manager-stat-card:hover .manager-stat-icon {\n  background: #dbeafe;\n  transform: scale(1.05);\n}\n\n.manager-stat-value {\n  margin-top: 8px;\n  color: #0b1220;\n  font-size: 24px;\n  font-weight: 850;\n  line-height: 1;\n}\n\n.manager-stat-note {\n  display: block;\n  margin-top: 5px;\n  color: #64748b;\n  font-size: 11.5px;\n  line-height: 1.25;\n}\n\n.manager-dashboard-row {\n  --bs-gutter-x: 12px;\n  --bs-gutter-y: 12px;\n  margin-top: 0 !important;\n  margin-bottom: 12px;\n}\n\n.manager-panel {\n  height: 100%;\n  padding: 13px;\n}\n\n.manager-panel-compact {\n  min-height: 225px;\n}\n\n.manager-pipeline-panel,\n.manager-pipeline-panel .p-card-body,\n.manager-pipeline-panel .p-card-content {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.manager-pipeline-panel {\n  height: 430px;\n}\n\n.manager-panel-table {\n  overflow: hidden;\n}\n\n.manager-coverage-panel,\n.manager-coverage-panel .p-card-body,\n.manager-coverage-panel .p-card-content {\n  display: flex;\n  flex-direction: column;\n}\n\n.manager-coverage-panel .p-card-body,\n.manager-coverage-panel .p-card-content {\n  height: 100%;\n  min-height: 0;\n}\n\n.manager-coverage-panel .manager-table {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.manager-coverage-panel .p-datatable-wrapper {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.manager-candidate-panel,\n.manager-team-panel {\n  height: 500px;\n}\n\n.manager-role-panel {\n  height: 440px;\n}\n\n.manager-panel-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 11px;\n}\n\n.manager-panel-title {\n  margin: 4px 0 0;\n  color: #071226;\n  font-size: 14px;\n  font-weight: 850;\n}\n\n.manager-pipeline-list,\n.manager-team-list {\n  display: grid;\n  gap: 9px;\n}\n\n.manager-pipeline-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding-right: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.manager-pipeline-row {\n  display: grid;\n  gap: 6px;\n  padding: 3px 0;\n  width: 100%;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n  transition: background-color 0.18s ease, transform 0.18s ease, padding 0.18s ease;\n}\n\n.manager-pipeline-row:hover,\n.manager-pipeline-row-active {\n  padding: 7px 8px;\n  border-radius: 10px;\n  background: #f8fbff;\n  transform: translateX(2px);\n}\n\n.manager-pipeline-copy {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  color: #334155;\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.manager-pipeline-copy strong {\n  color: #0b1220;\n}\n\n.manager-pipeline-track {\n  overflow: hidden;\n  height: 8px;\n  border-radius: 999px;\n  background: #e8eef7;\n}\n\n.manager-pipeline-fill {\n  height: 100%;\n  border-radius: inherit;\n  background: #2563eb;\n  transition: width 0.5s ease;\n}\n\n.manager-panel-clear {\n  min-height: 30px;\n  padding: 5px 12px;\n  border: 1px solid #bfdbfe;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 12px;\n  font-weight: 800;\n  transition: background-color 0.18s ease, transform 0.18s ease;\n}\n\n.manager-panel-clear:hover {\n  background: #dbeafe;\n  transform: translateY(-1px);\n}\n\n.manager-pipeline-candidates-panel {\n  min-height: 345px;\n}\n\n.manager-pipeline-screening {\n  background: #0ea5e9;\n}\n\n.manager-pipeline-interview {\n  background: #14b8a6;\n}\n\n.manager-pipeline-final-round {\n  background: #f59e0b;\n}\n\n.manager-pipeline-selected {\n  background: #22c55e;\n}\n\n.manager-pipeline-rejected {\n  background: #ef4444;\n}\n\n.manager-pipeline-received {\n  background: #2563eb;\n}\n\n.manager-pipeline-offered {\n  background: #8b5cf6;\n}\n\n.manager-pipeline-placed {\n  background: #22c55e;\n}\n\n.manager-pipeline-panel-round {\n  background: #f59e0b;\n}\n\n.manager-pipeline-shortlisted {\n  background: #0ea5e9;\n}\n\n.manager-pipeline-documentation {\n  background: #6366f1;\n}\n\n.manager-pipeline-task-assessment {\n  background: #ec4899;\n}\n\n.manager-pipeline-hold {\n  background: #64748b;\n}\n\n.manager-team-list {\n  max-height: 414px;\n  overflow-y: auto;\n  padding-right: 4px;\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.manager-summary-grid::-webkit-scrollbar,\n.manager-pipeline-list::-webkit-scrollbar,\n.manager-team-list::-webkit-scrollbar,\n.manager-dashboard-page .p-datatable-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.manager-summary-grid::-webkit-scrollbar-thumb,\n.manager-pipeline-list::-webkit-scrollbar-thumb,\n.manager-team-list::-webkit-scrollbar-thumb,\n.manager-dashboard-page .p-datatable-wrapper::-webkit-scrollbar-thumb {\n  border: 2px solid transparent;\n  border-radius: 999px;\n  background: #cbd5e1;\n  background-clip: padding-box;\n}\n\n.manager-team-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 8px;\n  padding: 11px;\n  border: 1px solid #dbe4ef;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;\n}\n\n.manager-team-row:hover {\n  border-color: #bfdbfe;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.06);\n  transform: translateY(-1px);\n}\n\n.manager-team-metrics {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.manager-team-metrics span {\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #475569;\n  font-size: 11.5px;\n  font-weight: 800;\n}\n\n.manager-table {\n  overflow: hidden;\n  border: 1px solid #d8e1ec;\n  border-radius: 10px;\n  background: #ffffff;\n  font-size: 12.5px;\n}\n\n.manager-table .p-datatable-thead > tr > th {\n  border-color: #d8e1ec !important;\n  border-right: 1px solid #d8e1ec !important;\n  background: linear-gradient(180deg, #f8fafc 0%, #f3f7fb 100%) !important;\n  color: #475569;\n  font-size: 10.5px;\n  font-weight: 850;\n  letter-spacing: 0.06em;\n  padding: 10px;\n  text-transform: uppercase;\n}\n\n.manager-table .p-datatable-tbody > tr > td {\n  border-color: #e2e8f0 !important;\n  border-right: 1px solid #e2e8f0 !important;\n  color: #334155;\n  padding: 9px 10px;\n  vertical-align: middle;\n  transition: background-color 0.16s ease, color 0.16s ease;\n}\n\n.manager-table .p-datatable-thead > tr > th:last-child,\n.manager-table .p-datatable-tbody > tr > td:last-child {\n  border-right: 0 !important;\n}\n\n.manager-table .p-datatable-tbody > tr:nth-child(even) > td {\n  background: #fcfdff;\n}\n\n.manager-table .p-datatable-tbody > tr:hover > td {\n  background: #eff6ff !important;\n}\n\n.manager-table .p-datatable-tbody > tr:last-child > td {\n  border-bottom: 0 !important;\n}\n\n.manager-table .p-datatable-emptymessage > td {\n  border: 0 !important;\n  color: #64748b;\n  padding: 20px 12px !important;\n}\n\n.manager-dashboard-page .p-datatable-scrollable .p-datatable-wrapper {\n  border-radius: 0 0 10px 10px;\n}\n\n.manager-dashboard-page .p-datatable-wrapper {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.manager-table-strong {\n  color: #0b1220;\n  font-weight: 850;\n}\n\n.manager-table-muted {\n  margin-top: 3px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.manager-card-detail-table-wrap {\n  max-height: 430px;\n  overflow: auto;\n  border: 1px solid #d8e1ec;\n  border-radius: 10px;\n  background: #ffffff;\n}\n\n.manager-card-detail-table {\n  width: 100%;\n  min-width: 980px;\n  border-collapse: collapse;\n  color: #334155;\n  font-size: 12.5px;\n}\n\n.manager-card-detail-table th,\n.manager-card-detail-table td {\n  border-right: 1px solid #e2e8f0;\n  border-bottom: 1px solid #e2e8f0;\n  padding: 9px 10px;\n  text-align: left;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.manager-card-detail-table th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: linear-gradient(180deg, #f8fafc 0%, #f3f7fb 100%);\n  color: #475569;\n  font-size: 10.5px;\n  font-weight: 850;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.manager-card-detail-table tr:nth-child(even) td {\n  background: #fcfdff;\n}\n\n.manager-card-detail-empty {\n  padding: 20px 12px;\n  color: #64748b;\n  font-size: 13px;\n}\n\n.manager-badge {\n  display: inline-flex;\n  align-items: center;\n  min-height: 24px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: #eff6ff;\n  color: #1d4ed8;\n  font-size: 11px;\n  font-weight: 850;\n  white-space: nowrap;\n}\n\n.manager-badge-screening {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.manager-badge-interview {\n  background: #ccfbf1;\n  color: #0f766e;\n}\n\n.manager-badge-final-round {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.manager-badge-selected {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.manager-badge-rejected {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.manager-badge-received {\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.manager-badge-offered {\n  background: #f5f3ff;\n  color: #6d28d9;\n}\n\n.manager-badge-placed {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.manager-badge-panel-round {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.manager-badge-shortlisted {\n  background: #e0f2fe;\n  color: #0369a1;\n}\n\n.manager-badge-documentation {\n  background: #e0e7ff;\n  color: #4338ca;\n}\n\n.manager-badge-task-assessment {\n  background: #fce7f3;\n  color: #be185d;\n}\n\n.manager-badge-hold {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.manager-dashboard-page .p-card .p-card-body,\n.manager-dashboard-page .p-card .p-card-content {\n  padding: 0 !important;\n}\n\n.manager-dashboard-page .p-datatable .p-paginator {\n  border: 0;\n  border-top: 1px solid #e2e8f0;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .manager-dashboard-page *,\n  .manager-dashboard-page *::before,\n  .manager-dashboard-page *::after {\n    animation-duration: 0.01ms !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .manager-summary-grid {\n    grid-template-columns: repeat(7, minmax(128px, 1fr));\n  }\n\n  .manager-filter-grid {\n    grid-template-columns: repeat(3, minmax(180px, 1fr));\n  }\n\n  .manager-candidate-panel,\n  .manager-team-panel,\n  .manager-role-panel {\n    height: auto;\n  }\n\n  .manager-pipeline-panel {\n    height: 390px;\n  }\n\n  .manager-team-list {\n    max-height: 360px;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .manager-dashboard-hero {\n    grid-template-columns: 1fr;\n  }\n\n  .manager-filter-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .manager-summary-grid {\n    grid-template-columns: repeat(7, minmax(132px, 1fr));\n  }\n\n  .manager-dashboard-page .container-fluid {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .manager-dashboard-shell {\n    padding-top: 8px;\n  }\n\n  .manager-dashboard-hero-copy,\n  .manager-dashboard-company-card,\n  .manager-dashboard-filter-card,\n  .manager-stat-card,\n  .manager-panel {\n    border-radius: 12px;\n  }\n\n  .manager-dashboard-hero-copy,\n  .manager-panel,\n  .manager-stat-card {\n    padding: 13px;\n  }\n\n  .manager-summary-grid,\n  .manager-filter-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .manager-summary-grid {\n    grid-template-columns: repeat(7, minmax(132px, 1fr));\n  }\n\n  .manager-pipeline-panel {\n    height: 360px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
